import React from 'react';
import { StyledBaseTable } from '@components/common/Table/styled';
import { AutoResizer } from 'react-base-table';
import { DataTableWrapper, TableWrapper } from '../styled';
import useFetchActiveOutliers from '@components/ai-roadmap/hooks/useFetchActiveOutliers';
import { Retry } from '@components/common';
import { dimensionSearchFn } from '../utils';
import Empty from '@components/viewer-sessions/table/Empty';
import { useSearch } from '../Search/useSearch';
import { activeTabSearchTextAtom } from '../atoms';

const ActiveOutliersTable = ({ getColumns }) => {
  const { orderedRows = [], isFetching, isError, refetch, onColumnSort, sortBy } = useFetchActiveOutliers();

  const { filteredRows, ...dimensionSearchProps } = useSearch({
    data: orderedRows,
    columnKey: 'dimensions',
    searchFn: dimensionSearchFn,
    searchTextAtom: activeTabSearchTextAtom
  });

  return (
    <TableWrapper>
      <Retry
        isLoading={isFetching}
        showError={isError}
        mountChildAlways={false}
        fetchData={refetch}
      >
        <DataTableWrapper>
          <AutoResizer>
            {({ width, height }) => {
              return (
                <StyledBaseTable
                  style={{
                    marginTop: '5px',
                    width: '100%',
                    display: 'flex',
                    flexGrow: 1,
                  }}
                  headerHeight={50}
                  rowHeight={50}
                  columns={getColumns(dimensionSearchProps)}
                  data={filteredRows}
                  emptyRenderer={<Empty />}
                  width={width}
                  height={height}
                  sortBy={sortBy}
                  onColumnSort={onColumnSort}
                />
              );
            }}
          </AutoResizer>
        </DataTableWrapper>
      </Retry>
    </TableWrapper>
  );
};

export default ActiveOutliersTable;
